import { Component, OnInit, ViewChild } from '@angular/core'
import { InitialPublicOfferingComponent } from '../initial-public-offering/initial-public-offering.component'
import { ProfitComponent } from '../profit/profit.component'
import { MatTabChangeEvent } from '@angular/material'
@Component({
  selector: 'app-compare-exchanges',
  templateUrl: './compare-exchanges.component.html',
  styleUrls: ['./compare-exchanges.component.scss']
})
export class CompareExchangesComponent implements OnInit {
  @ViewChild(ProfitComponent) profitComponent: ProfitComponent

  @ViewChild(InitialPublicOfferingComponent)
  initialPublicOfferingComponent: InitialPublicOfferingComponent
  constructor() {}

  ngOnInit() {
    localStorage.setItem('compareExchanges', '0')
  }

  onTabClick(event: MatTabChangeEvent) {
    localStorage.setItem('compareExchanges', event.index.toString())
    switch (event.index) {
      case 0:
        break
      case 1:
        this.initialPublicOfferingComponent.initialChart()
        break
      case 2:
        break
      case 3:
        this.profitComponent.initialChart()
        break
      default:
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/compare-exchanges/compare-exchanges.component.ts